/* La Passion Canine — onglets, quantités et ajout au panier (API AJAX native Shopify) */
(function () {
  if (window.__lpcInit) return; window.__lpcInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg, withLink) {
    var t = document.querySelector('.lpc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'lpc-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.innerHTML = '<span></span>' + (withLink ? '<a href="' + root + 'cart">Voir le panier</a>' : '');
    t.firstChild.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sel = '[data-cart-count],.cart-count,.cart-count-bubble span[aria-hidden],.cart-count-bubble,#CartCount,.cart__count,.header__cart-count,.js-cart-count';
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.closest('.lpc')) return;
          if (el.children.length && !el.matches('[data-cart-count]')) return;
          el.textContent = cart.item_count;
          el.hidden = false;
        });
        // évènements utilisés par de nombreux thèmes pour rafraîchir le mini-panier
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {});
  }

  // Onglets
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.lpc [role="tab"]');
    if (!tab) return;
    var box = tab.closest('[data-lpc-espace]');
    box.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    box.querySelectorAll('[data-lpc-voirtout]').forEach(function (a) { a.href = tab.dataset.url; });
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('.lpc [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus(); next.click(); e.preventDefault();
  });

  // Quantités
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.lpc [data-lpc-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var max = parseInt(input.max || '99', 10);
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.lpcStep, 10);
    input.value = Math.min(Math.max(v, 1), max);
  });

  // Ajout au panier
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.lpc form[data-lpc-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.lpc-add');
    var qty = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;
    btn.disabled = true; btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || "Impossible d'ajouter ce produit.", false); return; }
        toast('Ajouté au panier ✓', true);
        return refreshCartCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });
})();
